import { render, staticRenderFns } from "./GradientWrapper.vue?vue&type=template&id=12445a94&scoped=true&"
import script from "./GradientWrapper.vue?vue&type=script&lang=js&"
export * from "./GradientWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GradientWrapper.vue?vue&type=style&index=0&id=12445a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12445a94",
  null
  
)

export default component.exports